import { PageHeader } from '@ant-design/pro-layout';
import { Typography } from 'antd';
import { useEffect } from 'react';
import { Link, useMatch, useNavigate, useResolvedPath } from 'react-router-dom';
import { RouteDefinition, VerticalTabs } from '../../../shared/vertical-tabs';
import { SubPageLayout } from '../sub-page-layout';
import { ToolsIdForm } from './tools-id-form';
import { ToolsReportCoverLetter } from './tools-report-cover-letter';
import { ToolsVerificationForm } from './tools-verification-form';

interface ToolsPage {
  id: string;
  path: string;
  title: string;
}

export const Tools: React.FC = () => {
  const navigate = useNavigate();
  const currentRoutePath = useResolvedPath('').pathname;
  const currentRouteMatch = useMatch(`${currentRoutePath}`);

  const pages: ToolsPage[] = [
    {
      id: '1',
      path: 'id-form',
      title: 'ID Form'
    },
    {
      id: '2',
      path: 'verification-form',
      title: 'Verification Form'
    },
    {
      id: '3',
      path: 'report-cover-letter',
      title: 'Report Cover Letter'
    }
  ];

  const routes: RouteDefinition[] = [
    { id: '1', path: 'id-form', element: <ToolsIdForm /> },
    { id: '2', path: 'verification-form', element: <ToolsVerificationForm /> },
    { id: '3', path: 'report-cover-letter', element: <ToolsReportCoverLetter /> }
  ];

  const toolPageNavigationMenu = pages.map((page) => ({
    key: page.id,
    label: <Link to={page.path}>{page.title}</Link>,
    style: { width: '80%' }
  }));

  useEffect(() => {
    if (currentRouteMatch) {
      navigate(routes[0].path); // Redirect to 1st menu item
    }
  }, [currentRouteMatch, navigate]);

  return (
    <SubPageLayout header={<PageHeader title={<Typography.Title className="staff-title">Tools</Typography.Title>} />}>
      <VerticalTabs routes={routes} menuItems={toolPageNavigationMenu} />
    </SubPageLayout>
  );
};
